import React from 'react'
import {useSelector} from 'react-redux'
import FormComponent from './form.component'
import ModalHeaderAtom from '../../@atoms/to_layout/modal_header/modal_header.atom'
import NotifyPrefsWrapperAtom from '../../@atoms/to_content/notify_prefs_wrapper/notify_prefs_wrapper.atom'
import TypographyAtom from '../../@atoms/to_content/typography/typography.atom'
import {RootState} from '../../store_redux'

const NotifyPrefsComponent: React.FC = function () {
  const labels = useSelector((state: RootState) => state.labels)

  return (
    <NotifyPrefsWrapperAtom>
      <ModalHeaderAtom>
        <TypographyAtom ahd_type="h6">
          {labels.notificationModal.title}
        </TypographyAtom>
      </ModalHeaderAtom>
      <TypographyAtom ahd_type="step">
        {labels.notificationModal.description}
      </TypographyAtom>
      <FormComponent />
    </NotifyPrefsWrapperAtom>
  )
}

export default NotifyPrefsComponent
